import React from "react";

// ⭐ Utility to darken a hex color
export const darkenColor = (hex, amount = 20) => {
  let col = hex.replace("#", "");
  let num = parseInt(col, 16);

  let r = (num >> 16) - amount;
  let g = ((num >> 8) & 0x00FF) - amount;
  let b = (num & 0x0000FF) - amount;

  r = r < 0 ? 0 : r;
  g = g < 0 ? 0 : g;
  b = b < 0 ? 0 : b;

  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, "0")}`;
};

// ⭐ Export slider settings from this file
export const categorySliderSettings = {
  dots: false,
  infinite: false,
  autoplay:false,
  slidesToShow: 8.5,
  slidesToScroll: 2,
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,
  responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 6.2 } },
    { breakpoint: 1600, settings: { slidesToShow: 5.2 } },
    { breakpoint: 1200, settings: { slidesToShow: 4.8 } },
    { breakpoint: 992, settings: { slidesToShow: 4.1} },
    { breakpoint: 768, settings: { slidesToShow: 3.2 } },
    { breakpoint: 576, settings: { slidesToShow: 2.1 } },
    { breakpoint: 400, settings: { slidesToShow: 2.2 } },
    { breakpoint: 320, settings: { slidesToShow: 1.3 } },
  ],
};

const CategoryCard = ({ item }) => {
  return (
    <div className="bgColor">
      <div
        className="looking-card text-center"
        style={{
          backgroundColor: item.bg,
          border: `1px solid ${darkenColor(item.bg, 30)}`,
        }}
      >
        <div className="looking-inner">
          <img src={item.icon} alt={item.title} className="looking-img" />
          <h5 className="looking-title fw-bold">{item.title}</h5>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
